<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row class="mb-3">
          <v-col cols="12" md="4">
            <AutocompleteClass label="Lớp" hide-details outlined dense @change="onClassChanged" />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteSubject
              v-model="subjectData"
              label="Môn học"
              return-object
              hide-details
              outlined
              dense
              :filter="filterSubject"
              :disabled="!classData"
              @change="factorData = null"
            />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteSemester
              v-model="semesterData"
              placeholder="Chọn học kỳ"
              label="Học kỳ"
              outlined
              dense
              hide-details
              @change="semesterChanged"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <AutocompleteFactor
              v-model="factorData"
              label="Đầu điểm"
              outlined
              hide-details
              dense
              :disabled="!subjectData"
              :filter="filterFactor"
            />
          </v-col>
          <v-col cols="12" md="4">
            <DateIOSPicker
              outlined
              dense
              hide-details
              label="Ngày nhập"
              :date.sync="inputDate"
              @onEnterPress="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn
        outlined
        color="#0D47A1"
        :disabled="!classData || !subjectData || !factorData || !inputDate"
        @click="onFilterChanged"
      >
        Chọn Nhập
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteFactor from '@/components/basic/input/AutocompleteFactor'
import AutocompleteSemester from '@/components/basic/input/AutocompleteSemester'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import moment from 'moment'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteClass,
    AutocompleteSubject,
    AutocompleteFactor,
    AutocompleteSemester,
    DateIOSPicker
  },
  data: () => ({
    classData: '',
    subjectData: '',
    factorData: '',
    semesterData: '',
    subjects: [],
    factors: [],
    inputDate: '',
    windowWidth: window.innerWidth
  }),
  computed: {
    ...mapState('app', ['currentSemester']),
    filterFactor() {
      return {
        subject: get(this.subjectData, 'id'),
        semesterType: this.semesterData.type
      }
    },
    filterSubject() {
      return { division: get(this.classData, 'division.id'), grade: get(this.classData, 'grade.id') }
    }
  },
  created() {
    this.inputDate = moment().toISOString()
    this.semesterData = this.currentSemester
  },
  methods: {
    async onClassChanged(classData) {
      this.subjectData = null
      this.factorData = null
      this.classData = classData
    },
    onFilterChanged() {
      if (this.$refs.form.validate()) {
        const param = {
          class: this.classData,
          subject: this.subjectData,
          factor: this.factorData,
          semester: this.semesterData,
          date: this.inputDate
        }
        this.$emit('onFilterChanged', param)
      }
    },
    semesterChanged() {
      this.factorData = null
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
